module.exports = __webpack_public_path__ + "static/media/van.8da06541.svg";